<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Quality Management Folder"
      text="Edit Quality Management Folder"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localQualityManagementFolder.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col cols="12">
              <v-checkbox
                v-model="localQualityManagementFolder.is_private"
                disabled
              >
                <template v-slot:label>
                  <div>
                    Is Private?
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      qualityManagementFolder: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localQualityManagementFolder: null,
      }
    },
    computed: {
      isNameChanged () {
        return this.localQualityManagementFolder.name !== this.qualityManagementFolder.name
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localQualityManagementFolder = { ...this.qualityManagementFolder }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)
            if (this.isNameChanged) {
              this.$api.qualityManagementFolders().update(this.qualityManagementFolder.id, this.prepareFormData())
                .then(response => {
                  if (response.status === 200) {
                    this.$emit('updated')
                    this.$snack({ message: response.data.status })

                    this.dialog = false
                  }
                })
                .catch(() => {})
                .then(() => {
                  this.setProgressing(false)
                })
            } else {
              this.$snack({ message: 'No update has been done' })
              this.setProgressing(false)
              this.dialog = false
            } 
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        let data = { 
          name: this.localQualityManagementFolder.name, 
          is_private: this.localQualityManagementFolder.is_private, 
        }
        return data
      },
    },
  }
</script>
